<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('detailDispositif.mobilierUrbain.title.info') }}
      </p>
    </header>
    <div class="card-content columns is-multiline">
      <div class="column is-3">
        <b-field :label="$t('detailDispositif.mobilierUrbain.couleurRal')"
                 custom-class="has-text-link">
          <p class="has-text-default">{{ dispositifTechnique.couleurRAL }}</p>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('detailDispositif.mobilierUrbain.arretBus')"
                 custom-class="has-text-link">
          <p class="has-text-default">{{ dispositifPublicitaire.arretBus }}</p>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('detailDispositif.mobilierUrbain.valeurAcquisition')"
                 custom-class="has-text-link">
          <p class="has-text-default">
            {{ dispositifTechnique.valeurAcquisition | formatDevise }}
          </p>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('detailDispositif.mobilierUrbain.longueur')"
                 custom-class="has-text-link">
          <p class="has-text-default">
            {{ dispositifTechnique.longueur }}
          </p>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('detailDispositif.mobilierUrbain.largeurToit')"
                 custom-class="has-text-link">
          <p class="has-text-default">
            {{ dispositifTechnique.largeurToit }}
          </p>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('detailDispositif.mobilierUrbain.publicitaire')"
                 custom-class="has-text-link">
          <p class="has-text-default">
            {{ dispositifTechnique.publicitaire ? $t('general.oui') : $t('general.non') }}
          </p>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('detailDispositif.mobilierUrbain.codeTimeo')"
                 custom-class="has-text-link">
          <p class="has-text-default">
            {{ dispositifPublicitaire.codeTimeo }}
          </p>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('detailDispositif.mobilierUrbain.eclairable')"
                 custom-class="has-text-link">
          <p class="has-text-default">
            {{ dispositifTechnique.eclairable ? $t('general.oui') : $t('general.non') }}
          </p>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('detailDispositif.mobilierUrbain.avecCaissonPub')"
                 custom-class="has-text-link">
          <p class="has-text-default">
            {{ dispositifPublicitaire.avecCaissonPub ? $t('general.oui') : $t('general.non') }}
          </p>
        </b-field>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    dispositifPublicitaire: {
      type: Object,
      required: true,
    },
    dispositifTechnique: {
      type: Object,
      required: true,
    },
  },
};
</script>
